import axios from "axios";
import { createHeaders, createAuthHeaders } from "./Constant";

const hostname = window.location.hostname;
const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

const baseMap = {
  "customer-test.finhub.habilelabs.io": "/vkyc-backend/api",
  "endpoint-gateway-test.finhub.habilelabs.io": "https://endpoint-gateway-test.finhub.habilelabs.io/vkyc-backend/api"
};

const baseURL = isLocal
  ? "http://localhost:8000/api"
  : baseMap[hostname] || "https://endpoint-gateway-test.finhub.habilelabs.io/vkyc-backend/api";

export const auditLogService = {
  async createAuditLog(logData, user, company_id) {
    const url = `${baseURL}/v1/kyc/audit-log`;
    
    const response = await axios.post(url, logData, {
      headers: {
        ...createAuthHeaders(user),
        'Content-Type': 'application/json',
        'company_id': user?.company?.id || company_id
      }
    });
    
    return response.data;
  },

  async auditorDecision(applicantId, auditorStatus, user) {
    const url = `${baseURL}/v1/kyc/auditor-decision/${applicantId}`;
    
    const response = await axios.post(url, {
      auditor_status: auditorStatus
    }, {
      headers: {
        ...createAuthHeaders(user),
        'Content-Type': 'application/json',
      }
    });
    
    return response.data;
  },

  async updateApplicantStatus(applicantId, kycStatus, companyId) {
    const url = `${baseURL}/v1/kyc/update-kyc-status/${applicantId}`;
    
    const response = await axios.post(url, {
      kyc_status: kycStatus
    }, {
      headers: {
        ...createHeaders(),
        'Content-Type': 'application/json',
        'company_id': companyId
      }
    });
    
    return response.data;
  },

  async finalSubmission(customerSession, sessionId) {
    const url = `${baseURL}/v1/kyc/final-submission/${customerSession}`;
    
    const response = await axios.post(url, {
      session_id: sessionId
    }, {
      headers: {
        ...createHeaders(),
        'Content-Type': 'application/json',
      }
    });
    
    return response.data;
  }

};